import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Paper,
  Checkbox,
  FormControl,
  Select
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import { rowDetailType } from "./MemberTable";
//import Waveform from "../../component/common/waveSurfer/WaveForm.js";
import api from "../../../../API";
import ContractRejectRsnDialog from "../manage/contract/ContractRejectRsnDialog";
import PhotoIcon from '@mui/icons-material/Photo';
import DescriptionIcon from '@mui/icons-material/Description';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useSelector } from "react-redux";
import { Formik, Form } from "formik";
import RoleUpdateDialog from "./RoleUpdateDialog";


// interface userDetailProps {
  
// }
interface MemberDetailProps {
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  rowDetail: rowDetailType | null;
  setRowDetail: React.Dispatch<React.SetStateAction<rowDetailType>>;
  getMemberList: any;
}

const rowData: rowDetailType = {
  id: 0,
  email: "",
  name: "",
  gender: "",
  jumin: "",
  bank: "",
  bank_num: "",
  birth: "",
  phone: "",
  startDate: "",
  roles: []
};

const MemberDetailDialog = (props: MemberDetailProps) => {
  // console.log("props", props);
  const [data, setData] = useState<rowDetailType>(rowData);

  const [selectedAuth, setSelectedAuth] = useState('');

  const [auths, setAuths] = useState([]);

  const [documentFile, setDocumentFile] = useState([]);

  const [rejectPageOpen , setRejectPageOpen] = useState<boolean>(false);

  const [roleUpdateDialog , setRoleUpdateDialog] = useState<boolean>(false);

  const [roleUpdate , setRoleUpdate] = useState("");
  const [roleUpdateName , setRoleUpdateName] = useState("");

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;
  

  const getAuths = async () => {
    var result = await api.get("/getAuths");

    // console.log('맴버 디테일 팝업',result.data.data)
    setAuths(result.data.data);
    
    // setDocumentFile
  };

  const getDocumentFile = async (worker:string) => {
    await api.get("/getDocumentFile",{params:{email:email,worker:worker}})
      .then(response => {
        // console.log('getDocumentFile' ,response.data.datas)
        setDocumentFile(response.data.datas)
      })
      .catch((e:any) => console.log('sampleFileInfo error' , e));
  }

  const memberUpdateRole = async (values:any) => {


    
    await api.post("/memberUpdateRole",values)
      .then(response => {
        // console.log('getDocumentFile' ,response.data.datas)
        alert("권한 추가가 완료되었습니다.")
        props.setDialogOpen(false);
        props.getMemberList();
        // setDocumentFile(response.data.datas)
      })
      .catch((e:any) => console.log('사용자 권한 업데이트 실패' , e));
  }

  const memberStopAssignMent = async (worker:string) => {
    
    const formData = new FormData();

    formData.append("email", email);
    formData.append("worker", worker);

    await api.post("/stopAssignMent",{email:email,worker:worker})
      .then(response => {
        // console.log('getDocumentFile' ,response.data.datas)
        alert("중도 하차 처리가 완료되었습니다.")
        props.setDialogOpen(false);
        props.getMemberList();
        console.log('중도 하차 콘솔', response)
        // setDocumentFile(response.data.datas)
      })
      .catch((e:any) => {console.log('중도 하차 처리 실패' , e);alert(e.response.data.error)});
  }

  const closeDialogAfterRoleUpdate = () => {
    props.setDialogOpen(false);
    props.getMemberList();
  }

  const [dialogSize , setDialogSize] = useState(false)
  const [photoUrl , setPhotoUrl] = useState("")

  const [documentFileName, setDocumentFileName] = useState("")

  const getDocumentFileInfo = async (idx:number, file_type:string, file_name:string) => {

    if(file_type === "photo"){
      setDialogSize(true);
      setPhotoUrl("http://121.135.229.125/api/sampleFileInfo?document=true&idx="+idx+"&file_type="+file_type)
    }else{
      // setPhotoUrl("")
      // console.log('pdf 클릭')
      setDialogSize(false)
      await api.get("/sampleFileInfo?document=true&idx="+idx+"&file_type="+file_type,{ responseType: 'blob' })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file_name);
        document.body.appendChild(link);
        link.click();
      })
      .catch((e:any) => console.log('sampleFileInfo error' , e));
    }

  };

  useEffect(() => {
    getAuths();
    // console.log("MemberDetailDialog");
    if (props.rowDetail != null){
      setData(props.rowDetail);
      getDocumentFile(props.rowDetail.email)
      
    }
    
  }, [props.rowDetail]);

  return (
    <Box >
    <Dialog maxWidth={dialogSize ? "xl" : "md"} open={true} fullWidth={true}>
      <DialogTitle sx={{padding: "16px 24px 0px 24px"}}>
        <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>사용자 상세정보</Box>
        <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      </DialogTitle>
      <DialogContent dividers>
      <Box display="flex" justifyContent="center">
      
        <Box>
        <form>
        <Box display="flex">
          <Box sx={{width:"100%", margin:"8px"}}>
            <Box m={1} display="flex" sx={{alignItems:"center"}}>
              <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>이메일</Box>
              <TextField
                id="email"
                 value={data.email}
                type="email"
                variant="standard"
                sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                InputProps={{
                  readOnly: true,
                }}
              />
              <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>이름</Box>
            <TextField
              id="name"
              value={data.name}
              variant="standard"
              sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}></TextField>

                </Box>
            <Box m={1} display="flex" sx={{alignItems:"center"}}>
              <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>성별</Box>
            <TextField
              id="gender"
               value={data.gender}
              variant="standard"
              sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
              InputProps={{
                readOnly: true,
              }}
              />
              <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>생년월일</Box>
            <TextField
              id="birth"
               value={data.birth}
              variant="standard"
              sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}></TextField>

            </Box>
            <Box m={1} display="flex" sx={{alignItems:"center"}}>
              {/* <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>권한</Box>
            <TextField
              id="roles"
               value={data.roles}
              variant="standard"
              sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
              InputProps={{
                readOnly: true,
              }}
              /> */}
              <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>가입일</Box>
              <TextField
                id="startDate"
                value={data.startDate}
                variant="standard"
                sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}/>

            </Box>
            <Box m={1} display="flex" sx={{alignItems:"center"}}>
              <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>주민번호</Box>
            <TextField
              id="jumin"
               value={data.jumin}
              variant="standard"
              sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
              InputProps={{
                readOnly: true,
              }}
              />
              <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>전화번호</Box>
            <TextField
               id="phone"
               value={data.phone}
              variant="standard"
              sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}></TextField>
            </Box>
            <Box m={1} display="flex" sx={{alignItems:"center"}}>
              <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>은행명</Box>
            <TextField
              id="bank"
               value={data.bank}
              variant="standard"
              sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
              InputProps={{
                readOnly: true,
              }}
              />
              <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>계좌번호</Box>
            <TextField
               id="bank_num"
               value={data.bank_num}
              variant="standard"
              sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}></TextField>
            </Box>
            </Box>
        </Box>

        <Box>
          <Box sx={{marginLeft:"2px",marginTop:"16px", marginRight:"20px", fontWeight:700, fontSize: "16px", letterSpacing:"-2px"}}>문서제출</Box>
          <Box sx={{width: "95%", border: "3px solid #3e36a5", borderRadius: "3px", margin: "12px", padding: "8px", display:"block" , justifyContent:"center"}}>

            {documentFile.length > 0 ? 
              <React.Fragment>
                {documentFile.map((documentFile:any,idx:number) => 
                  {
                      return (
                        <Box key={idx+1} display="flex" sx={{marginBottom:"4px", marginLeft:"32px"}}>
                          <Box sx={{marginRight:"40px"}}>{documentFile.file_type === "photo" ? <PhotoIcon/> : <DescriptionIcon/>}</Box>
                          <Box sx={{width:"390px",fontWeight:700}}>{documentFile.origin_file_name}</Box>
                          <Box sx={{margin:"auto"}}>
                            <Button sx={{backgroundColor: (documentFile.file_type === "pdf"? "#2344d6" : "#ff9800"), fontWeight:700}} size="small" variant="contained" onClick={()=>{getDocumentFileInfo(documentFile.idx,documentFile.file_type,documentFile.origin_file_name); setDocumentFileName(documentFile.origin_file_name) ;}}>
                            {documentFile.file_type === "pdf" ? "다운": "확인"}
                            </Button>
                          </Box>
                        </Box>
                      )
                  }
                )}
              </React.Fragment>
            :""}
          </Box>
        </Box>

        <Box>
          <Box sx={{marginLeft:"2px",marginTop:"16px", marginRight:"20px", fontWeight:700, fontSize: "16px", letterSpacing:"-2px"}}>권한목록</Box>
          <List
            dense
            sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
          >
            {auths.length !== 0 ? (
              auths.map((auth: any) => {
                const labelId = `checkbox-list-secondary-label-${auth.code_nm}`;
                // console.log('유저 데이터' , data, auth)
                
                return (
                  data.roles.map((role:any) => {    
                    if(role.role == auth.code){
                      return (
                        <ListItem
                          key={auth.code}
                          secondaryAction={
                            <Checkbox
                              edge="end"
                              id={auth.code}
                              checked={true}
                              inputProps={{ "aria-labelledby": labelId }}
                              onChange={(e)=> {
                                // alert(`${data.email}의 \n ${auth.code_nm} : 해당 권한을 삭제하시겠습니까?`)
                                setRoleUpdateDialog(true)
                                setRoleUpdate(auth.code)
                                setRoleUpdateName(auth.code_nm)
                                }
                              }
                            />
                          }
                          disablePadding
                        >
                          <ListItemButton>
                            <ListItemText id={labelId} primary={`${auth.code_nm} ${role.role == "VIE" ? (" ("+ role.user_id + ")") : ""} ${role.type == "dialog" ? "[대화]" : (role.type == "noise" ? "소음" : (role.type == "sound" ? "소리" : ""))}`} />
                          </ListItemButton>
                        </ListItem>
                      )
                    }
                  })
                )
              })
            ) : ""}
          </List>
        </Box>
          
        </form>
        {email == 'jjk02272@naver.com' ? <Button variant="contained" color="error" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            memberStopAssignMent(data.email);
          }}
        >
          대화음성중도하차
        </Button>:""}
        
        {roleUpdateDialog ? <RoleUpdateDialog email={email} worker={data.email} roleUpdateName={roleUpdateName}  roleUpdate={roleUpdate} setRoleUpdateDialog={setRoleUpdateDialog} closeDialogAfterRoleUpdate={closeDialogAfterRoleUpdate} /> : "" }

        <Box>
          <Box sx={{marginLeft:"2px",marginTop:"16px", marginRight:"20px", fontWeight:700, fontSize: "16px", letterSpacing:"-2px"}}>권한추가</Box>
          <Box sx={{ minWidth: 120 }}>
            <FormControl sx={{width:"300px"}}>
            <Formik
              initialValues={{email:email,worker:"", role:selectedAuth}}
              onSubmit={(values) => {
                console.log("권한 추가", values);
                // console.log("이메일????" , data.email)
                memberUpdateRole(values)
              }}
            >
              {({ values, handleChange, setFieldValue, submitCount }) => (
                <Form>
              {/* <InputLabel id="demo-simple-select-label">권한</InputLabel> */}
              {/* <input id="worker" name="worker" value={data.email} hidden={true} /> */}
              <Select
                labelId="demo-simple-select-label"
                id="role" 
                name="role"
                value={values.role}
                label="권한"
                sx={{width:"200px", height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                onChange={(e)=> {
                  // setRole(e.target.value)
                  console.log('권한 ??? ' , e.target.value)
                  // setSelectedAuth(e.target.value)
                  handleChange(e);
                  setFieldValue("worker" , data.email);
                }
                }
              >
                {auths.length !== 0 ? (
                  auths.map((auth: any, index:number) => {
                    // console.log('권한' , auth,data.user_id)
                    // if(!selectedAuth && (data.user_id.split('_')[0] == auth.code)) {
                    //   setSelectedAuth(auth.code)
                    // }
                    // console.log('권한' , data.user_id)
                    // if(data.user_id != '' && selectedAuth == '') setSelectedAuth('NKI')
                      
                    // const labelId = `checkbox-list-secondary-label-${auth.code_nm}`;
                    return (
                      // <MenuItem selected={data.user_id.split('_')[0] == auth.code ? true : false} key={auth.code} dense value={auth.code}>{auth.code_nm}</MenuItem>
                      <MenuItem key={auth.code} dense value={auth.code}>{auth.code_nm}</MenuItem>
                    );
                  })
                ) : (
                  []
                )}
              </Select>
              <Button variant="contained" type="submit" >추가</Button>
              </Form>
              )}
            </Formik>
            </FormControl>
          </Box>
        </Box>

      </Box>

        

        {dialogSize && photoUrl != "" ?
          <Box>
              <Box display="flex">
                <Box sx={{marginLeft:"18px", marginRight:"auto", marginBottom:"12px", fontWeight:700, fontSize: "16px"}}>이미지 : {documentFileName}</Box>
                {/* <Box><Button sx={{margin:"auto"}} variant="contained" onClick={()=> setDialogSize(false)}>닫기</Button></Box> */}
                <Box><HighlightOffIcon sx={{cursor:"pointer", marginRight:"16px"}} onClick={()=> setDialogSize(false)} /></Box>
              </Box>
              <Paper sx={{padding:"4px", border:"3px solid #3e36a5", width:"654px" , height:"654px", overflow: "hidden", position: "relative"}}>
                <img src={photoUrl} style={{width: "100%", height: "auto", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}} />
                {/* <Button variant="contained" onClick={()=> setDialogSize(false)}>닫기</Button> */}
              </Paper>
          </Box>:""}


        

      </Box>


        {/* </form> */}
      </DialogContent>
        

          <DialogActions>
            <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
              onClick={() => {
                props.setDialogOpen(false);
              }}
            >
              취소
            </Button>
            </DialogActions>
      {/* 취소
        </Button>
        <Button variant="contained" color="error" sx={{fontWeight:700, margin:"8px 16px"}}
          // onClick={() => { */}
          {/* //   // sampleReject();
          //   setRejectPageOpen(true);
          // 
        > */}

          {/* 샘플 검수반려
        {/* </Button>
        <Button variant="contained" sx={{fontWeight:700, margin:"8px 16px"}} */}
          {/* // onClick={() => { */}
          {/* //   sampleConfirm();
          //  */}
    </Dialog>
    {rejectPageOpen ? <ContractRejectRsnDialog email={data.email} setRejectPageOpen={setRejectPageOpen} getMemberList={props.getMemberList} /> : ""}
    </Box>
  );
};

export default MemberDetailDialog;
